export const ENTITY_LIST_DATA_IDS = {
  base: 'entity-list',
  bodyContainer: 'body-container',
  container: 'container',
  content: 'content',
  toolbar: 'toolbar'
};
